Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URL_GOLPE_INTERMEDIARIO = exports.URL_ENTENDA_CHAT = exports.URL_DETALHES_VENDA = exports.URL_DENUNCIA = exports.URL_COMPRA_SEGURA = void 0;
var URL_DENUNCIA = 'https://chatmod-redirects.olxbr.com/denuncia';
exports.URL_DENUNCIA = URL_DENUNCIA;
var URL_COMPRA_SEGURA = 'https://garantia-da-olx.olx.com.br/garantia-da-olx/';
exports.URL_COMPRA_SEGURA = URL_COMPRA_SEGURA;
var URL_DETALHES_VENDA = 'https://meus-pedidos.olx.com.br/minhas-vendas';
exports.URL_DETALHES_VENDA = URL_DETALHES_VENDA;
var URL_GOLPE_INTERMEDIARIO = 'https://chatmod-redirects.olxbr.com/golpe-do-intermediario';
exports.URL_GOLPE_INTERMEDIARIO = URL_GOLPE_INTERMEDIARIO;
var URL_ENTENDA_CHAT = 'https://chatmod-redirects.olxbr.com/como-funciona';
exports.URL_ENTENDA_CHAT = URL_ENTENDA_CHAT;